import { updateCart } from 'components/Cart/actions';
import { DiscountResponseStatus } from 'models/DiscountResponseStatus';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteDiscount, postDiscount } from 'services/ApiCheckoutPageService';
import { rm } from 'utils';

interface SubmitDiscount {
  isDelete: boolean;
}

const submitDiscountDefault = {
  isDelete: false
} satisfies SubmitDiscount;

export const useUpdateDiscount = () => {
  const [code, setCode] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const dispatch = useDispatch();

  const submitDiscount = async ({ isDelete }: SubmitDiscount = submitDiscountDefault) => {
    setLoading(true);

    const nextAction = isDelete ? deleteDiscount(code) : postDiscount({ code, pin: '' });

    return nextAction
      .then(result => {
        if (result.cart) {
          dispatch(updateCart({ cart: result.cart }));
          setErrorMessage('');
        }

        const errorMessage = errorMessageMap[result.status];
        if (!errorMessage) return;

        const message = rm(errorMessage);
        setErrorMessage(message);
      })
      .catch(() => setErrorMessage(rm('error_generic_short')))
      .finally(() => setLoading(false));
  };

  return {
    submitDiscount,
    errorMessage,
    isLoading,
    setCode,
    code
  };
};

const errorMessageMap = {
  [DiscountResponseStatus.Success]: '',
  [DiscountResponseStatus.Unknown]: 'checkout_discount_error_invalid',
  [DiscountResponseStatus.Pin]: 'checkout_discount_error_invalid',
  [DiscountResponseStatus.Empty]: 'checkout_discount_error_invalid',
  [DiscountResponseStatus.Expired]: 'checkout_discount_error_invalid',
  [DiscountResponseStatus.ToLong]: 'checkout_discount_error_invalid',
  [DiscountResponseStatus.HasWhiteSpace]: 'checkout_discount_error_invalid',
  [DiscountResponseStatus.ContainsAdminDiscounts]: 'checkout_discount_error_invalid'
};
